import { config } from 'aws-cognito-redux-saga';

function getSession() {
  // aws-cognito-redux-saga nests the Cognito helpers under config.config (see Auth.js).
  const cognito = config.config || config;
  const user = cognito.getUserPool() && cognito.getUser();
  if (!user) return Promise.reject(new Error('Sign in to view the dashboard.'));
  return new Promise((resolve, reject) => {
    user.getSession((error, session) => error ? reject(error) : resolve(session));
  });
}

export default async function dashboardRequest(path) {
  const session = await getSession();
  const response = await fetch(process.env.REACT_APP_NODE_ROOT_URL + path, {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + session.getIdToken().getJwtToken()
    },
    cache: 'no-store'
  });
  if (!response.ok) {
    if (response.status === 403) {
      window.location.replace(localStorage.getItem('us_limited') === '1' ? '/customer-orderentry' : '/customer');
    }
    throw new Error('Unable to load dashboard (HTTP ' + response.status + ').');
  }
  return response.json();
}
